import axios from 'axios'

let wx = window.wx
export function share(data) {
  return axios
    .post(
      '//api20.zai-art.com/service/wechat/signature',
      { param: { noncestr: `zai-art${+new Date()}`, url: location.href.split('#')[0] } },
      { timeout: 60000, headers: { 'Content-Type': 'application/json' } }
    )
    .then(response => {
      let dataset = response.data.data
      // alert(JSON.stringify(dataset))
      wx.config({
        debug: false,
        appId: dataset.appid,
        timestamp: parseInt(dataset.timestamp),
        nonceStr: dataset.noncestr,
        signature: dataset.signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'chooseWXPay',
          'closeWindow'
        ],  
        openTagList: ['wx-open-launch-weapp'], 
      })
      wx.ready(() => {
        // 分享到朋友圈
        wx.onMenuShareTimeline(data)
        // 分享给朋友
        wx.onMenuShareAppMessage(data)
        // 分享到QQ
        wx.onMenuShareQQ(data)
        // 分享到腾讯微博
        wx.onMenuShareWeibo(data)
        // 分享到QQ空间
        wx.onMenuShareQZone(data)
      })
    })
}
